/**
 * Configuración del administrador (N8N, Evolution API, pie de página, etc.).
 * Se persiste en localStorage y tiene prioridad sobre las variables de entorno.
 */

const STORAGE_KEY = "crm_admin_settings"

const DEFAULTS = {
  // N8N
  n8nWebhookUrl: "",
  // Evolution API
  evolutionApiUrl: "",
  evolutionApiKey: "",
  evolutionInstance: "",
  // Pie de página / branding
  footerText: "",
  hostingLabel: "",
}

/**
 * @returns {typeof DEFAULTS}
 */
export function getAdminSettings() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return { ...DEFAULTS }
    const parsed = JSON.parse(raw)
    return { ...DEFAULTS, ...parsed }
  } catch {
    return { ...DEFAULTS }
  }
}

/**
 * Guarda parcialmente la configuración (solo las claves que envíes).
 * @param {Partial<typeof DEFAULTS>} partial
 */
export function setAdminSettings(partial) {
  try {
    const current = getAdminSettings()
    const next = { ...current, ...partial }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
    if (typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent("crm_admin_settings_updated"))
    }
    return next
  } catch (e) {
    console.warn("[admin-config] setAdminSettings error:", e)
    return getAdminSettings()
  }
}

/**
 * URLs/keys para uso en runtime (prioridad: localStorage > env).
 */
export function getEvolutionApiUrl() {
  const s = getAdminSettings()
  return (s.evolutionApiUrl && s.evolutionApiUrl.trim()) || import.meta.env.VITE_EVOLUTION_API_URL || ""
}

export function getEvolutionApiKey() {
  const s = getAdminSettings()
  return (s.evolutionApiKey && s.evolutionApiKey.trim()) || import.meta.env.VITE_EVOLUTION_API_KEY || ""
}

export function getEvolutionInstance() {
  const s = getAdminSettings()
  return (s.evolutionInstance && s.evolutionInstance.trim()) || import.meta.env.VITE_EVOLUTION_INSTANCE || ""
}

export function getN8nWebhookUrl() {
  const s = getAdminSettings()
  return (s.n8nWebhookUrl && s.n8nWebhookUrl.trim()) || import.meta.env.VITE_N8N_WEBHOOK_URL || ""
}

/**
 * Texto del pie de página (ej. "Powered by N8N" o nombre del hosting).
 */
export function getFooterText() {
  const s = getAdminSettings()
  const text = (s.footerText && s.footerText.trim()) || ""
  const hosting = (s.hostingLabel && s.hostingLabel.trim()) || ""
  if (text && hosting) return `${text} · ${hosting}`
  return text || hosting || ""
}
